import Carousel from "./components/Carousel.js";
import YouTube from "./components/YouTube.js";
import Header from "./components/Header.js";
import Scrolly from "./components/Scrolly.js";
import Dropdown from "./components/Dropdown.js";
import Installations from "./components/Installations.js";
import Timeline from "./components/Timeline.js";
import Excerpt from "./components/Excerpt.js";
import SmoothScroll from "./components/SmoothScroll.js";
import PageTransition from "./components/PageTransition.js";
import TextReveal from "./components/TextReveal.js";
import CardReveal from "./components/CardReveal.js";
import ParallaxImage from "./components/Parralax.js";
import FooterReveal from "./components/FooterReveal.js";

export default class ComponentFactory {
	constructor() {
		this.componentInstances = [];
		this.componentList = {
			Header,
			Scrolly,
			Carousel,
			YouTube,
			Dropdown,
			Installations,
			Timeline,
			SmoothScroll,
			Excerpt,
			PageTransition,
			TextReveal,
			CardReveal,
			ParallaxImage,
			FooterReveal,
		};
		this.init();
	}
	init() {
		const components = document.querySelectorAll('[data-component]');

		for (let i = 0; i < components.length; i++) {
			const element = components[i];
			const componentNames = element.dataset.component.split(' ');

			componentNames.forEach(componentName => {
				if (this.componentList[componentName]) {
					const instance = new this.componentList[componentName](element);
					this.componentInstances.push(instance);
				} else {
					console.log(`La composante ${componentName} n'existe pas`);
				}
			});
		}
	}
}
